import nl from "./nl.json";
import en from "./en.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import pt from "./pt.json";
import pl from "./pl.json";
import { createI18n } from "vue-i18n";

export const supportedLocales = [
    "nl",
    "en",
    "de",
    "es",
    "fr",
    "pt",
    "pl",
] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

function getInitialLocale(): SupportedLocale {
    const saved = localStorage.getItem("app_locale");
    if (saved && supportedLocales.includes(saved as SupportedLocale)) {
        return saved as SupportedLocale;
    }

    const browserLocale = (navigator.language?.substring(0, 2) ||
        document.documentElement.lang ||
        "nl") as string;

    if (supportedLocales.includes(browserLocale as SupportedLocale)) {
        return browserLocale as SupportedLocale;
    }

    return "nl";
}

export default createI18n({
    locale: getInitialLocale(),
    fallbackLocale: "en",
    legacy: false,
    messages: {
        nl,
        en,
        de,
        es,
        fr,
        pt,
        pl,
    },
});
